import { Loader } from '@/components/Loader';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useMyLeaderboardStats } from '@/sections/customerManagement/hooks/data/useMyLeaderboardStats';

import { CodeActivityChart } from './CodeActivityChart';
import { ImprovementAccordion } from './ImprovementAccordion';
import { MetricRadarChart } from './MetricRadarChart';
import { ScoreProgressionChart } from './ScoreProgressionChart';
import { StatCards } from './StatCards';

export function MyStats() {
  const { currentEntry, progression, codeActivity, radarData, status } =
    useMyLeaderboardStats();

  if (status === 'pending') {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <Loader isLoading type="spinner" />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <p className="text-chariot-text-secondary text-sm">
          Failed to load your stats.
        </p>
      </div>
    );
  }

  if (!currentEntry) {
    return (
      <div className="flex h-full items-center justify-center py-12">
        <p className="text-chariot-text-secondary text-sm">
          No leaderboard data found for your account.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <StatCards
        entry={currentEntry}
        progression={progression}
        radarData={radarData}
      />

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="text-sm font-medium">
              Score Progression (7 Days)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ScoreProgressionChart data={progression} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="text-sm font-medium">
              Metric Strengths
            </CardTitle>
          </CardHeader>
          <CardContent>
            <MetricRadarChart data={radarData} />
          </CardContent>
        </Card>
      </div>

      {codeActivity.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className="text-sm font-medium">
              Code Activity (7 Days)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <CodeActivityChart data={codeActivity} />
          </CardContent>
        </Card>
      )}

      <ImprovementAccordion radarData={radarData} />
    </div>
  );
}
